export default "__VITE_ASSET__sGtMr609__"